export const SESSION_REGISTRATION_BUTTON_FORM_NAME = 'sessionRegistrationButtonFormName'
export const INSTITUTION_RESERVATION_FORM_NAME = 'institutionFSPRegistration'
export const INSTITUTION_ASSIGN_FORM_NAME = 'institutionFSPRegistrationAssignments'
export const INDIVIDUAL_RESERVATION_FORM_NAME = 'individualFSPRegistration'
export const WAITLIST_FORM_NAME = 'waitlistFSPRegistration'
